import React from 'react';
import { IconSearch, IconArrowRight, IconCheck, IconTarget, IconShield, IconBolt } from './Icons';
import { useLanguage } from '../context/LanguageContext';
import useScrollReveal from '../hooks/useScrollReveal';
import './SEOSection.css';

const SEOSection = () => {
  const { t } = useLanguage();
  const features = [
    { icon: 'search', title: t.seoSection.feature1Title, description: t.seoSection.feature1Desc },
    { icon: 'target', title: t.seoSection.feature2Title, description: t.seoSection.feature2Desc },
    { icon: 'shield', title: t.seoSection.feature3Title, description: t.seoSection.feature3Desc },
    { icon: 'bolt', title: t.seoSection.feature4Title, description: t.seoSection.feature4Desc },
  ];

  const getIcon = (iconType) => {
    switch(iconType) {
      case 'search': return <IconSearch size={20} />;
      case 'target': return <IconTarget size={20} />;
      case 'shield': return <IconShield size={20} />;
      case 'bolt': return <IconBolt size={20} />;
      default: return <IconCheck size={20} />;
    }
  };

  const headerReveal = useScrollReveal({ threshold: 0.1 });
  const featuresReveal = useScrollReveal({ threshold: 0.1 });

  return (
    <section className="seo-section-fox" id="seo">
      <div className="seo-section-fox__bg-orb seo-section-fox__bg-orb--1"></div>
      <div className="seo-section-fox__bg-orb seo-section-fox__bg-orb--2"></div>
      <div className="seo-section-fox__bg-grid"></div>
      
      <div className="seo-section-fox__container">
        <div ref={headerReveal.ref} className={`seo-section-fox__text-content reveal ${headerReveal.isRevealed ? 'reveal--visible' : ''}`}>
          <div className="seo-section-fox__label reveal-child">
            <IconSearch size={22} />
            {t.seoSection.label}
          </div>
          <h2 className="seo-section-fox__title reveal-child">
            {t.seoSection.title} <span className="seo-section-fox__title-gradient">{t.seoSection.titleHighlight}</span>
          </h2>
          <p className="seo-section-fox__tagline reveal-child">{t.seoSection.tagline}</p>
          <p className="seo-section-fox__description reveal-child">{t.seoSection.description}</p>
          
          <div ref={featuresReveal.ref} className={`seo-section-fox__features reveal ${featuresReveal.isRevealed ? 'reveal--visible' : ''}`}>
            {features.map((feature, index) => (
              <div key={index} className="seo-section-fox__feature reveal-child">
                <span className="seo-section-fox__feature-icon">{getIcon(feature.icon)}</span>
                <div className="seo-section-fox__feature-content">
                  <span className="seo-section-fox__feature-title">{feature.title}</span>
                  <span className="seo-section-fox__feature-text">{feature.description}</span>
                </div>
              </div>
            ))}
          </div>

          <a href="#contact" className="seo-section-fox__cta-button">
            {t.seoSection.cta}
            <span className="seo-section-fox__cta-icon">
              <IconArrowRight size={16} />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default SEOSection;
